import { TagProps } from "@chakra-ui/react";
import { BasicUser, User } from "models/user";
import SkeletonTag from "../SkeltonTag";
import NameTag from "../NameTag";

export interface UserTagProps extends TagProps {
  isLoading?: boolean;
  user: BasicUser | User | undefined;
  imageUrl?: string | undefined;
  roleName?: string | undefined;
  tagLabelProps?: object;
  size?: "sm" | "md";
  includeRoleName?: boolean;
}

function getDisplayText({
  user,
  roleName,
  includeRoleName,
}: Pick<UserTagProps, "user" | "roleName" | "includeRoleName">) {
  if (!user) {
    return roleName ? `Missing ${roleName}` : "None";
  }
  if (user?.deactivatedAt) {
    const firstNameLetter = user.firstName ? `${user.firstName[0]}. ` : "";
    return `${firstNameLetter}${user.lastName} (deactivated)`;
  }

  return roleName && includeRoleName ? `${user.fullName} (${roleName})` : user.fullName;
}

export default function UserTag({
  isLoading,
  user,
  roleName,
  size,
  includeRoleName,
  tagLabelProps,
  ...props
}: UserTagProps) {
  if (!isLoading) {
    return <SkeletonTag size={size} />;
  }
  return (
    <NameTag
      name={getDisplayText({ user, roleName, includeRoleName })}
      size={size}
      tagLabelProps={tagLabelProps}
      {...props}
    />
  );
}
